import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Nyjah from "../../assets/nyjah_banner.png";
import AppLogo from "../../assets/ONLY RYAN LOGO RED.png";
import axios from "axios";
import { useEffect, useState } from "react";
import { LogRow } from "../../Models/log";
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from "@mui/material";
import MainBoldFont from "../../fonts/Google_Sans_Code/GoogleSansCode-VariableFont_wght.ttf";
import {
  MobileView,
  BrowserView,
  isMobile,
  isMobileSafari,
} from "react-device-detect";
import { tournamentStore } from "../../Store/store";

export const DataPlayground: React.FC = () => {
  const { tournamentID } = useParams();
  const nav = useNavigate();
  return (
    <Container
      fluid
      style={{
        background: "transparent",
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <Row style={{ minHeight: "100%" }}>
        {/* Left Column: Fixed height, no scrolling */}
        {!isMobile && (
          <Col
            md={3}
            className="layout-container"
            style={{
              height: "100vh",
              overflow: "hidden",
              background: "transparent",
              display: "flex",
              position: "sticky",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <img
              className="sticky-col"
              src={Nyjah}
              alt="Banner"
              style={{ width: "auto", height: "80%", objectFit: "cover" }}
            /> */}
          </Col>
        )}

        {/* Middle Column: Scrollable table container */}
        <Col
          md={6}
          style={{
            minHeight: "100vh",
            overflow: "hidden",
            paddingTop: 50,
            background: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Row>
            <h1 className="player" style={{ fontFamily: MainBoldFont }}>
              <span>
                <img src={AppLogo} height={20} />{" "}
              </span>{" "}
            </h1>
          </Row>
          <FootballTable tournamentID={tournamentID!} />
          <Row style={{ padding: "50px" }}>
            <h1>
              Prize Pool &mdash;
              <span style={{ color: "tomato", fontWeight: "bolder" }}>
                {" "}
                ZAR 3,000.00
              </span>
            </h1>
          </Row>
          <Row style={{ margin: 50 }}>
            <label>
              Last updated {new Date().toDateString()} &mdash; To participate,
              please read our{" "}
              <a href="https://onlyryan.co.za/tou">Terms of Use</a> and{" "}
              <a href="https://onlyryan.co.za/pp">Privacy Policy</a>
            </label>
          </Row>
        </Col>
        <Col
          md={3}
          style={{
            height: "100vh",
            overflow: "hidden",
            background: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            padding: "50px",
            alignItems: "center",
          }}
        ></Col>
      </Row>
    </Container>
  );
};

const FootballTable: React.FC<{ tournamentID: string }> = ({
  tournamentID,
}) => {
  const [data, setData] = useState<LogRow[] | null>(null);
  const [loading, setLoading] = useState<boolean | null>(null);

  const loadResults = () => {
    const obj = { id: tournamentID } as { id: string };
    setLoading(true);
    axios
      .get(`https://getlogv2-ktninsi3ma-uc.a.run.app?id=${obj.id}`)
      .then((v) => {
        console.log(v);
        const val = v.data as unknown as any;
        if (val) {
          setData(val["value"] as LogRow[]);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (loading === null) {
      loadResults();
    }
  }, [loading]);

  if (loading === null) {
    return <></>;
  }

  if (isMobile || isMobileSafari) {
    return (
      <div style={{ display: "flex", flexFlow: "column" }}>
        {data?.map((row, i) => (
          <TableSmartRow row={row} i={i} />
        ))}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        background: "transparent",
        margin: 0,
        padding: 0,
        flexFlow: "column",
        minHeight: "80vh",
        width: "100%",
        textAlign: "center",
      }}
    >
      <TableContainer
        style={{ background: "transparent", margin: 0, padding: 0 }}
      >
        <Table sx={{}} size="medium" aria-label="a dense table">
          <TableHead
            style={{
              visibility: isMobile || isMobileSafari ? "hidden" : "visible",
            }}
          >
            <TableRow>
              <TableCell>
                <b>#</b>
              </TableCell>
              <TableCell align="center">
                <b></b>
              </TableCell>
              <TableCell align="center">
                <b>Games</b>
              </TableCell>
              <TableCell align="center">
                <b>Win</b>
              </TableCell>
              <TableCell align="center">
                <b>Draw</b>
              </TableCell>
              <TableCell align="center">
                <b>Lose</b>
              </TableCell>
              <TableCell align="center">
                <b>Points</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, i) => (
              <TableSmartRow row={row} i={i} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const TableSmartRow: React.FC<{ row: LogRow; i: number }> = ({ row, i }) => {
  const qualified = i + 1 < 9;

  if (isMobile || isMobileSafari) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexFlow: "column",
          padding: 10,
          border: "1px solid transparent",
          background: "whitesmoke",
          marginTop: "10px",
          borderBottom: "2px solid tomato",
        }}
        key={row.playerID}
      >
        <div
          style={{
            display: "flex",
            flexFlow: "row",
            border: "1px solid transparent",
          }}
        >
          <h3 style={{ padding: 1, display: "flex", flexFlow: "row" }}>
            <span
              style={{
                paddingRight: "10px",
                background: "whitesmoke",
                borderRadius: 0,
                textAlign: "start",
              }}
            >{`#${i + 1}`}</span>
            <b className="player" style={{ fontFamily: MainBoldFont }}>
              {qualified && <span style={{ color: "tomato" }}>&#9679; </span>}
              {row.playerNickname}{" "}
            </b>
          </h3>
        </div>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            padding: "0px",
            margin: 0,
            display: "flex",
            flexFlow: "row",
          }}
        >
          <span style={{ width: "25%" }}>{`Played : ${row.games}`}</span>
          <span
            style={{
              width: "25%",
              textAlign: "center",
              fontWeight: "bolder",
              color: "tomato",
            }}
          >{`Points : ${row.points}`}</span>
          <span style={{ width: "25%" }}>{`Wins : ${row.wins}`}</span>
          <span style={{ width: "25%" }}>{`Loses : ${row.loss}`}</span>
        </div>
      </div>
    );
  }

  return (
    <TableRow
      style={{ fontFamily: MainBoldFont }}
      key={row.playerID}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        {"" + (i + 1)}
      </TableCell>
      <TableCell align="left">
        <h2 className="player">
          <b style={{ fontFamily: MainBoldFont }}>
            {row.playerNickname}{" "}
            {qualified && <span style={{ color: "tomato" }}>&#9679;</span>}
          </b>
        </h2>
      </TableCell>
      <TableCell
        align="center"
        style={{ background: "whitesmoke", fontFamily: MainBoldFont }}
      >
        <h2>{row.games}</h2>
      </TableCell>
      <TableCell
        align="center"
        style={{ background: "whitesmoke", fontFamily: MainBoldFont }}
      >
        <h2>{row.wins}</h2>
      </TableCell>
      <TableCell
        align="center"
        style={{ background: "whitesmoke", fontFamily: MainBoldFont }}
      >
        <h2>{row.draws}</h2>
      </TableCell>
      <TableCell align="center" style={{ background: "whitesmoke" }}>
        <h2>{row.loss}</h2>
      </TableCell>
      <TableCell
        align="center"
        style={{
          background: "tomato",
          color: "white",
          fontFamily: MainBoldFont,
        }}
      >
        <h2 style={{ fontFamily: MainBoldFont }}>
          {" "}
          <b>{row.points}</b>{" "}
        </h2>
      </TableCell>
    </TableRow>
  );
};
